export default (function (path, formData) {
  var fetchOptions = {
    body: formData,
    credentials: "same-origin",
    method: "POST",
    headers: {
      Accept: "application/json"
    }
  };
  return fetch(path, fetchOptions);
});